import React, { useState } from 'react';
import Header from './Header';
import {
  Button,
  Card,
  Container,
  Divider,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid,
  Paper,
  Typography
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import SportsPerformanceResults from './SportsPerformanceResults';

function Results({ formData, results }) {
  
  if (formData.trainingGoal === 'sportsPerformance') return <SportsPerformanceResults programs={results} />;

  let primaryRecommendation = results[0];
  let secondaryRecommendations = results.slice(1);

  let trainingGoal;

  switch (formData.trainingGoal) {
    case 'weightlifting':
      trainingGoal = 'I train to compete in Olympic Weightlifting';
      break;
    case 'crossfit':
      trainingGoal = 'I want to improve my Olympic lifts for CrossFit';
      break;
    case 'sport':
      trainingGoal = 'I want to be more athletic for my team sport';
      break;
    default:
      trainingGoal = 'I train for fun and/or to stay in shape';
  }

  return (
    <React.Fragment>
      <Header title="YOUR RESULTS ARE IN!" />
      <Container maxWidth="md" style={{ padding: '1rem' }}>
        <Card raised>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6} style={{ padding: '2rem' }}>
              {Array.isArray(primaryRecommendation.thumbnail) ? (
                primaryRecommendation.thumbnail.map((thumbnail, idx) => (
                  <Paper
                    component="img"
                    elevation={3}
                    key={idx}
                    src={thumbnail}
                    style={{ display: 'block', margin: '1rem auto', maxWidth: '85%' }}
                  />
                ))
              ) : (
                <Paper
                  component="img"
                  elevation={3}
                  src={primaryRecommendation.thumbnail}
                  style={{ display: 'block', margin: 'auto', maxWidth: '85%' }}
                />
              )}
            </Grid>
            <Grid item xs={12} md={6} style={{ alignItems: 'center', display: 'flex' }}>
              <Grid container spacing={2} style={{ margin: 'auto', maxWidth: '85%' }}>
                <Grid item xs={12}>
                  <Typography
                    align="center"
                    component="h5"
                    style={{ fontWeight: 'bold' }}
                    variant="h5"
                  >
                    {primaryRecommendation.programName}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Divider variant="middle" />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    align="center"
                    color="textSecondary"
                    component="p"
                    variant="body2"
                  >
                    {primaryRecommendation.msg}
                  </Typography>
                </Grid>
                {formData.email ? (
                  <Grid item xs={12}>
                    <Typography
                      align="center"
                      component="p"
                      variant="body2"
                    >
                      Sign up in the next 24 hours and save 20% on your first month when you use code: <span style={{ fontWeight: 'bold' }}>{primaryRecommendation.promo}</span>
                    </Typography>
                  </Grid>
                ) : null}
                {formData.firstResponder === 'true' ? (
                  <Grid item xs={12}>
                    <Typography
                      align="center"
                      component="p"
                      variant="body2"
                    >
                      Thank you for your service! Save 15% on your recurring membership, use code: <span style={{ fontWeight: 'bold' }}>{primaryRecommendation.discount}</span>
                    </Typography>
                  </Grid>
                ) : null}
                <Grid item xs={12} style={{ display: 'flex' }}>
                  <DateRangeIcon />
                  <Typography variant="body1">
                    Training sessions / week: {primaryRecommendation.sessions}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex' }}>
                  <CheckBoxIcon />
                  <Typography variant="body1">
                    Focused on your goal: {`"${trainingGoal}"`}
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ marginBottom: '2rem' }}>
                  <Button
                    color="primary"
                    fullWidth
                    href={primaryRecommendation.url}
                    style={{ fontWeight: 'bold', height: '150%' }}
                    variant="contained"
                  >
                    Learn More
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
        {secondaryRecommendations.length > 0 ? (
          <React.Fragment>
            <Card raised style={{ marginTop: '1rem' }}>
              <ExpansionPanel>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                >
                  <Typography
                    align="center"
                    style={{ fontWeight: 'bold' }}
                  >
                    Your next best program is...
                  </Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails style={{ flexDirection: 'column' }}>
                    {secondaryRecommendations.map((recommendation, idx) => {
                      return (
                        <Paper key={idx} elevation={3} style={{ margin: '1rem' }}>
                          <Grid container justify="center">
                            <Grid item xs={12} md={4} style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>
                              <Paper
                                component="img"
                                elevation={3}
                                src={recommendation.thumbnail}
                                style={{ display: 'block', margin: 'auto', maxWidth: '75%' }}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Grid container spacing={1} style={{ maxWidth: '85%', margin: 'auto', marginTop: '1rem' }}>
                                <Grid item xs={12}>
                                  <Typography
                                    style={{ fontWeight: 'bold' }}
                                  >
                                    {recommendation.programName}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Divider variant="fullWidth" />
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography
                                    color="textSecondary"
                                    component="p"
                                    variant="body2"
                                  >
                                    {recommendation.msg}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                                  <Button
                                    fullWidth
                                    href={recommendation.url}
                                    // style={{ maxWidth: '65%', marginBottom: '1rem' }}
                                    variant="outlined"
                                  >
                                    Learn More
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>
                      );
                    })}
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Card>
          </React.Fragment>
        ) : null}
      </Container>
    </React.Fragment>
  );
}

export default Results;